export default "__VITE_ASSET__DyulYXF1__"